import * as yup from "yup";
import { TFunction } from "i18next";

export const getYupSchemaForReportManagement = (t: TFunction) => {
  return yup.object().shape({
    nameRu: yup
      .string()
      .required(t("validation.required"))
      .max(250, t("validation.more250")),
  });
};
